import _styled from"@emotion/styled";import{mediaQuery}from"@wp/src/components/common/grid";import{wrappedTextStyles}from"@wp/src/components/common/atoms";const Title=_styled.span`
  ${wrappedTextStyles}
  ${mediaQuery({fontSize:["14px","16px","16px","16px","18px","20px"],lineHeight:["14px","16px","16px","20px","24px","32px"]})}
  ${{"fontWeight":"500","--tw-text-opacity":"1","color":"rgb(28 25 38 / var(--tw-text-opacity))"}}
`;export{Title};export default Title;